export const adminProfile = {
    genericImage: "/Generic-Profile-Image.png",
    name:"",
    adminProfileImage: "",
}